module.exports = __webpack_public_path__ + "assets/38006b65d85bfc29c278c18194e0b562.png";